import { render, staticRenderFns } from "./incometaxApproveBulk.vue?vue&type=template&id=a8f1b620&scoped=true"
import script from "./incometaxApproveBulk.vue?vue&type=script&lang=js"
export * from "./incometaxApproveBulk.vue?vue&type=script&lang=js"
import style0 from "./incometaxApproveBulk.vue?vue&type=style&index=0&id=a8f1b620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f1b620",
  null
  
)

export default component.exports